import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, timeout } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const authService = inject(AuthService);

    return authService.getAuthSession().pipe(
        timeout(10000),
        map((session) => {
            console.log('Auth session:', session);
            const isAuthenticated = session?.tokens?.idToken != null;
            if (!isAuthenticated) {
                return router.createUrlTree(['/public']);
            }
            return isAuthenticated;
        }),
        catchError((error) => {
            console.error('Error fetching session:', error);
            return of(router.createUrlTree(['/public']));
        })
    );
};
